import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { ConnectionService } from '@services/connection-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { resolveCheckoutRouting } from './checkout-routing.helper';

export const reviewOrderGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const resolution = await resolveCheckoutRouting(
    route,
    inject(ConnectionService),
    inject(ExperimentService),
  );

  if (resolution.skip || !resolution.hasDefaultAddress) return true;
  return router.createUrlTree(['/user/checkout'], { queryParams: route.queryParams });
};
